import React from "react";
import { nanoid } from "nanoid";
import { useSelector } from "react-redux";

import { Card } from "@lightspeed/flame/Card";
import arrow from "../../../assets/arrow.png";

import SideListItem from "./sideList/SideListItem";

const SideList = ({
  label,
  list,
  listN,
  openList,
  setOpenList,
  setDashMain,
  current,
  onItemClick,
}) => {
  const ui = useSelector((state) => state.ui);
  const companies = Array.isArray(list) ? list : [];
  const hasCompanies = companies.length > 0;
  const openLists = Array.isArray(openList.current) ? openList.current : [];
  const hasLabel = Boolean(label);
  const isOpen = !hasLabel || openLists.includes(listN);
  //const [activeItem, setActiveItem] = useState(null); // added 23.9.2024

  return (
    <div className="side-list-wrapper">
      {hasLabel && (
        <div
          onClick={(_) => {
            if (!hasCompanies) return;

            setOpenList({
              current: isOpen
                ? openLists.filter((openListN) => openListN !== listN)
                : [...openLists, listN],
            });
          }}
          className={`side-label ${isOpen ? "rotate" : ""} ${
            hasCompanies ? "" : "side-label-disabled"
          }`}
        >
          <p>{label}</p>
          {hasCompanies && <img src={arrow} alt="arrow" />}
        </div>
      )}
      <Card
        className={`side-list-card ${ui.theme === "flame" ? "" : "dark2"} ${
          isOpen ? "expand-side-list" : ""
        }`}
      >
        {!hasCompanies && (
          <SideListItem
            item={{ company_id: 1, company_name: "no items" }}
            setDashMain={setDashMain}
            //onClick={() => setActiveItem(1)} // added 23.9.2024
          />
        )}

        {companies.map((item) => (
          <SideListItem
            current={current}
            key={item.company_id || nanoid()}
            item={item}
            listN={listN}
            setDashMain={setDashMain}
            onClick={onItemClick}
            //active={activeItem === item.company_id} // added 23.9.2024
            //onClick={() => setActiveItem(item.company_id)} // added 23.9.2024
          />
        ))}
      </Card>
    </div>
  );
};

export default SideList;
